module.exports = __webpack_public_path__ + "media/images/emoticons/mobaq-60a296259564e5355148402c2b041e16.gif";